var SocialPopularHowtoSolutions = {
  init: function() {
    this.setVariables();
    this.retrieveSolutions();
  },
  setVariables: function() {
    this.$solutionList = $('#socialPopularHowtoSolutions');
    this.$noContent = $('#noSocialPopularHowtoSolutions');
    this.$popularCollection = $("#searchaliases").val();
  },
  retrieveSolutions: function() {
    var _self = this;

    var url = Config.contextPath + "/app/customportlets/sage/popularitems/worker.jsp";
    var data = {
      SToken: Config.csrf.value,
      items: "sagePopularItems",
      timerange: "lastweek",
      collection: this.$popularCollection,
      target: 'howto'
    };

    $.post(url, data)
      .done(function(r) {

        var hasItems = r !== undefined && r.sagePopularItems !== undefined && r.sagePopularItems.length > 0;

        if (hasItems) {
          var items = r.sagePopularItems;

          for (var i = 0; i < items.length; i++) {
            var $link = $("<a>");
            $link.text(items[i].title);
            $link.attr("href", Config.contextPath + "/app/portlets/results/viewsolution.jsp?solutionid=" + items[i].id);
            var $li = $("<li></li>");
            $li.append($link);
            _self.$solutionList.append($li);
          }
        } else {
          _self.$solutionList.addClass("hide");
          _self.$noContent.removeClass("hide");
        }
      });
  }
};